/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function(themeCurrency) {
  // Add custom code below this line
  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: 'screen and (max-width: '+ 990 +'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    stickyHeader: false,
    rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
  };

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

  /**
   * Footer section for mobile version
   */
  // Footer Quicklinks
  var accordion = document.querySelectorAll(".site-footer .footer__block button");
  var allLinkLists = document.querySelectorAll(".site-footer .footer__block .footer__quicklinks");
  allLinkLists[allLinkLists.length-1].style.border = "none";

  for (var i = 0; i < accordion.length; i++){
      accordion[i].addEventListener('click', function(){
        accordionClick(event);
      });
  }

  var accordionClick = (eventHappened) => {
    var targetClicked =event.target;
    var linkList = targetClicked.nextElementSibling;
    var expander = targetClicked.children[0];

    if (linkList.style.maxHeight){
      linkList.style.maxHeight = null;
      expander.innerHTML = "&#10133;";
    } else {
      for (var i = 0; i < allLinkLists.length; i++){
        if (allLinkLists[i].style.maxHeight){
          allLinkLists[i].style.maxHeight = null;
          allLinkLists[i].previousElementSibling.children[0].innerHTML = "&#10133;"
        }
      }

      linkList.style.maxHeight = linkList.scrollHeight + "px";
      expander.innerHTML = "&#10134;";
    }
  }
  
  /**
   * Custom content section
   */

  theme.parallaxSections = {};

  theme.Parallax = (function() {
    var speed = 0.85;
    var reset = false;
  
    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector('.parallax-image');
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;

      
      if (!this.container || !this.image) {
        return;
      }
  
      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        document.addEventListener('unmatchSmall', function() {
          this.init(true);
        }.bind(this));
      }
  
      this.init(this.desktopOnly);
    }
  
    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function(desktopOnly) {
        
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy();
        }
  
        this.isInit = true;

        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }
  
        // Set position on page load
        this.setSizes();
        this.scrollHandler();
  
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            
            if (this.isVisible) {
              window.on('scroll' + this.namespace, this.onScroll.bind(this));
            } else {
              window.off('scroll' + this.namespace);
            }
          });
        }, {rootMargin: '200px 0px 200px 0px'});
  
        observer.observe(this.container);
      },
  
      onScroll: function() {
        if (!this.isVisible) {
          return;
        }
  
        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }
  
        requestAnimationFrame(this.scrollHandler.bind(this));
      },
  
      scrollHandler: function() {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
      },
  
      setSizes: function() {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },
  
      onReorder: function() {
        this.setSizes();
        this.onScroll();
      },
  
      destroy: function() {
        this.image.style.transform = 'none';
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);
      }
    });
  
    return parallax;
  })();
  
  theme.CustomContent = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container',
      parallaxImage: '.parallax-image'
    };
  
    function CustomContent(container) {
      this.container = container;
      if (!container) {
        return;
      }
  
      var sectionId = container.getAttribute('data-section-id');
      this.namespace = '.' + sectionId;

      /*if (screen.width < 750) {
        this.container.querySelector(selectors.parallaxContainer).classList.remove('parallax-container');
        this.container.querySelector(selectors.parallaxImage).classList.remove('parallax-image');
      }*/

      this.init();
    }
  
    CustomContent.prototype = Object.assign({}, CustomContent.prototype, {
      init: function() {
        if (this.container.querySelector('.brick__block__image').dataset && this.container.querySelector('.brick__block__image').dataset.parallax) {
          var parallaxContainer = this.container.querySelector(selectors.parallaxContainer);

          var args = {
            namespace: this.namespace + '-parallax',
            desktopOnly: true
          };
          
          window.addEventListener('load', function() {
            theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
          })
          
        }
      },
  
      onUnload: function(evt) {
        if (!this.container) { return }
        if (theme.parallaxSections[this.namespace] && typeof theme.parallaxSections[this.namespace].destroy === 'function') {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return CustomContent;
  })();

  /**
   * Testimonials section
   */

  theme.Testimonials = (function() {
  
    var selectors = {
      reviewsSlider: '.reviews__slider'
    };
  
    function Testimonials(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        var $reviewsSliderContainer = $(selectors.reviewsSlider);
        
        $reviewsSliderContainer.slick({
          infinite: false,
          speed: 300,
          dots: true,
          prevArrow: '<span class="Icon Icon--media-arrow-left"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="184.000000pt" height="127.000000pt" viewBox="0 0 184.000000 127.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,127.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none"><path d="M310 953 c-162 -168 -297 -309 -298 -314 -2 -5 132 -149 299 -320 l302 -310 48 47 48 47 -219 227 c-121 125 -220 230 -220 234 0 3 353 6 785 6 l785 0 0 65 0 65 -786 0 c-471 0 -784 4 -782 9 2 5 101 110 220 234 l217 224 -47 46 c-26 26 -50 47 -52 46 -3 -1 -138 -138 -300 -306z"/></g></svg></span>',
          nextArrow: '<span class="Icon Icon--media-arrow-right"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="184.000000pt" height="127.000000pt" viewBox="0 0 184.000000 127.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,127.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none"><path d="M1178 1214 l-47 -48 220 -227 c120 -124 219 -229 219 -233 0 -3 -353 -6 -785 -6 l-785 0 0 -65 0 -65 786 0 c471 0 784 -4 782 -9 -1 -5 -101 -110 -220 -234 l-217 -224 48 -47 47 -46 155 157 c401 409 449 459 449 468 -1 6 -137 149 -303 318 l-302 308 -47 -47z"/></g></svg></span>',
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            }
          ]
        });
      }
    });
  
    return Testimonials;
  })();

  theme.BlogSection = (function() {
  
    var selectors = {
      blogSlider: '.blog-listing-section'
    };
  
    function BlogSection(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
      this.infiniteBlog();
    }
  
    BlogSection.prototype = Object.assign({}, BlogSection.prototype, {
      init: function() {
        var $articleSliderContainer = $('.blog-section').find(selectors.blogSlider);
        
        $articleSliderContainer.slick({
          infinite: false,
          speed: 300,
          dots: true,
          centerMode: false,
          prevArrow: '<span class="Icon Icon--media-arrow-left"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="184.000000pt" height="127.000000pt" viewBox="0 0 184.000000 127.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,127.000000) scale(0.100000,-0.100000)" fill="#000" stroke="none"><path d="M310 953 c-162 -168 -297 -309 -298 -314 -2 -5 132 -149 299 -320 l302 -310 48 47 48 47 -219 227 c-121 125 -220 230 -220 234 0 3 353 6 785 6 l785 0 0 65 0 65 -786 0 c-471 0 -784 4 -782 9 2 5 101 110 220 234 l217 224 -47 46 c-26 26 -50 47 -52 46 -3 -1 -138 -138 -300 -306z"/></g></svg></span>',
          nextArrow: '<span class="Icon Icon--media-arrow-right"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="184.000000pt" height="127.000000pt" viewBox="0 0 184.000000 127.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,127.000000) scale(0.100000,-0.100000)" fill="#000" stroke="none"><path d="M1178 1214 l-47 -48 220 -227 c120 -124 219 -229 219 -233 0 -3 -353 -6 -785 -6 l-785 0 0 -65 0 -65 786 0 c471 0 784 -4 782 -9 -1 -5 -101 -110 -220 -234 l-217 -224 48 -47 47 -46 155 157 c401 409 449 459 449 468 -1 6 -137 149 -303 318 l-302 308 -47 -47z"/></g></svg></span>',
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 3.3,
                slidesToScroll: 1,
                dots: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                dots: true
              }
            },
            {
              breakpoint: 320,
              settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1,
                dots: true
              }
            }
          ]
        });
      },

      infiniteBlog: function() {
        var e = $("#infinite-link"),
            t = e.children("a"),
            i = $(".custom-blog-listing");
        e.length > 0 &&
            t.on("click", function (e) {
                t.addClass("btn--disabled").text("Loading ...");
                var n = $(this).attr("href");
                $.ajax({
                    url: n,
                    success: function (e) {
                        var n = $(e),
                            s = n.find("a.article"),
                            o = n.find("#infinite-link");

                            s.css("display", "none"), 
                            i.append(s), 
                            s.slideDown(300), 
                            o.length > 0 ? t.removeClass("btn--disabled").text("More posts").prop("href", o.children("a").prop("href")) : t.text("All posts loaded");
                    },
                }),
                e.preventDefault();
            });
      }
    });
  
    return BlogSection;
  })();

  theme.AQISection = (function() {
    function AQISection(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
    }
  
    AQISection.prototype = Object.assign({}, AQISection.prototype, {
      init: function() {
        var activeIndex = $('.active-tab').index(),
            $contentlis = $('.tabs-content li'),
            $tabslis = $('.tabs li');
        
        // Show content of active tab on loads
        $contentlis.eq(activeIndex).show();

        $('.tabs').on('click', 'li', function (e) {
          var $current = $(e.currentTarget),
              index = $current.index();
          
          $tabslis.removeClass('active-tab');
          $current.addClass('active-tab');
          $contentlis.hide().eq(index).show();
        });
      }
    });
  
    return AQISection;
  })();

  theme.FilterTabSection = (function() {
    function FilterTabSection(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
    }
  
    FilterTabSection.prototype = Object.assign({}, FilterTabSection.prototype, {
      init: function() {
        var activeIndex = $('.active-cont').index(),
            $contentlis = $('.cont-content li'),
            $tabslis = $('.cont li');
        
        // Show content of active tab on loads
        $contentlis.eq(activeIndex).show();

        $('.cont').on('click', 'li', function (e) {
          var $current = $(e.currentTarget),
              index = $current.index();
          
          $tabslis.removeClass('active-cont');
          $current.addClass('active-cont');
          $contentlis.hide().eq(index).show();
        });
      }
    });
  
    return FilterTabSection;
  })();

  theme.UpsellProductSection = (function() {
    function UpsellProductSection(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
    }
  
    UpsellProductSection.prototype = Object.assign({}, UpsellProductSection.prototype, {
      init: function() {
        this.$wrapper =  $('.upsell-product-wrapper')
        this.productHandle = this.$wrapper.data('product-handle')
        this.$price = $('#template-product').find('.product__price');
        let $selectedOption = this.$wrapper.find('#upsell-variant-selector').find('option:selected');
                        
        this.subscriptionId = parseInt(this.$wrapper.find('[name="upsell-subscribe"]').eq(0).data('subscription-id'));
        this.subscriptionVariantId = parseInt(this.$wrapper.find('[name="upsell-subscribe"]').eq(0).data('id'));
        this.variantId =  parseInt(this.$wrapper.find('#upsell-variant-selector').val());

        var comparePrice = themeCurrency.formatMoney($selectedOption.data("compare-price"), theme.moneyFormat);
        var price = themeCurrency.formatMoney($selectedOption.data('price'), theme.moneyFormat);
        if($selectedOption.data("compare-price")){
          this.$price.html(price + '<span class="compare" data-product-price>' + comparePrice + '</span>');
        }else{
          this.$price.html(`
              <span data-product-price>${themeCurrency.formatMoney($(current).data('price'), theme.moneyFormat)}</span>
              `)
        }

        $(".affirm-as-low-as").attr("data-amount", $selectedOption.data('price'))
        if(affirm){
          if(affirm.ui){
            affirm.ui.refresh();
          }
        }
        this.handleEvents()
      },

      handleEvents: function() {
        let _self = this
        let $subscribeInput = _self.$wrapper.find('[name="upsell-subscribe"]')
        let $variantInput = _self.$wrapper.find('#upsell-variant-selector')
        let $addToCart = $('#template-product').find('.product__submit__add--upsell');
        //let $multiSelect = $(`.product__form__select`)[0]

        let $multiSelect = $('input[name=id]');

        $subscribeInput.on('change',function(){
          _self.subscriptionId = $(this).data('subscription-id')
          _self.subscriptionVariantId = $(this).data('id')
          if($(this).val() === 'subscribe'){
              let prevValue = $variantInput.find('option:selected').data('index')
              $variantInput.find('option').prop('selected', false)
              $variantInput.find(`option[data-duplicated]:eq(${prevValue})`).prop('selected', true).trigger('change')
          }else{
              let prevValue = $variantInput.find('option:selected').data('index')
              $variantInput.find('option').prop('selected', false)
              $variantInput.find(`option[data-orignal]:eq(${prevValue})`).prop('selected', true).trigger('change')
          }
        })

        $variantInput.on('change',function(){
          _self.variantId = parseInt($(this).val())
          let option = $(this).find(`option:selected`) 
          _self.updateView(option)
        })

        _self.observeElement($multiSelect, "value", function (oldValue, newValue) {
            
            let $variantInput = _self.$wrapper.find('#upsell-variant-selector')

            let actualIndex = $variantInput.find(`option[value=${newValue}]`).data('index')
            let isDuplicated = $variantInput.find('option:selected').data('duplicated')
            if(isDuplicated){
                $variantInput.find(`option[data-duplicated]:eq(${actualIndex})`).prop('selected', true).trigger('change')
            }else{
                $variantInput.find(`option[data-orignal]:eq(${actualIndex})`).prop('selected', true).trigger('change')
            } 
        });


        $multiSelect.on('change',function(){
          let newValue = $(this).val()
        })

        $addToCart.on('click',_self.handleAddToCart.bind(_self))
      },

      handleAddToCart: function(e) {
        console.log('test');
        e.preventDefault()
        let _self = this

        let $addToCart = $('#template-product').find('.product__submit__add--upsell')
        $addToCart.addClass('loading')
        let code = new Date().getTime() 
        let items = []
        if(_self.subscriptionVariantId){
          items= [
            {
              id: _self.variantId,
              quantity: parseInt($('#Quantity').val()),
              properties:{
                "_relatedProduct":`${_self.subscriptionVariantId}:${code}`,
                "_isDiscounted":true
              }
            },{
              id: _self.subscriptionVariantId,
              quantity: parseInt($('#Quantity').val()),
              selling_plan:_self.subscriptionId,
              properties:{
                "_isSubscription":true,
                "_relatedProduct":`${_self.variantId}:${code}`
              }
            }
          ]
        }else{
          items= [
            {
              id: _self.variantId,
              quantity: parseInt($('#Quantity').val())
            }   
          ]   
        }
        $.ajax({
          method:'POST',
          url:'/cart/add.js',
          dataType: 'json',
          data:{items},
          success:function(a){
              $addToCart.removeClass('loading')
              window.location.href = '/cart'
          },
          error: function(error){
            $addToCart.removeClass('loading')
            alert(error.responseJSON.message+': '+error.responseJSON.description);
          }
        })
      },

      updateView: function(current) {
        let _self = this
        $(".affirm-as-low-as").attr("data-amount", $(current).data('price'))
        
        if(affirm){
          if(affirm.ui){
            affirm.ui.refresh();
          }
        }
        if($(current).data("compare-price")){
        _self.$price.html(`
            ${themeCurrency.formatMoney($(current).data('price'), theme.moneyFormat)}<span class="compare" data-product-price>${themeCurrency.formatMoney($(current).data("compare-price"), theme.moneyFormat)}</span>       
            `)
        }else{
          _self.$price.html(`
          <span data-product-price>${themeCurrency.formatMoney($(current).data('price'), theme.moneyFormat)}</span>
          `)      	
        }
      },

      observeElement: function(element, property, callback, delay = 0) {
        let elementPrototype = Object.getPrototypeOf(element);
        if (elementPrototype.hasOwnProperty(property)) {
          let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);
          Object.defineProperty(element, property, {
            get: function() {
              return descriptor.get.apply(this, arguments);
            },
            set: function () {
              let oldValue = this[property];
              descriptor.set.apply(this, arguments);
              let newValue = this[property];
              if (typeof callback == "function") {
                setTimeout(callback.bind(this, oldValue, newValue), delay);
              }
              return newValue;
            }
          });
        }
      }
    });
  
    return UpsellProductSection;
  })();

  theme.EssentialFAQSection = (function() {
    function EssentialFAQSection(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
    }
  
    EssentialFAQSection.prototype = Object.assign({}, EssentialFAQSection.prototype, {
      init: function() {
        var accordion = document.querySelectorAll(".faq-item__question");
        var answers = document.querySelectorAll(".faq-item__answer");
        //answers[0].style.maxHeight = answers[0].scrollHeight + "px";

        for (var i = 0; i < accordion.length; i++){
            accordion[i].addEventListener('click', function() {
              accordionClick(event);
            });
        }

        var accordionClick = (eventHappened) => {
          var targetClicked = event.target;
          var content = targetClicked.nextElementSibling;

          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            for (var i = 0; i < answers.length; i++){
              if (answers[i].style.maxHeight){
                answers[i].style.maxHeight = null;
              }
            }

            content.style.maxHeight = content.scrollHeight + "px";
          }
        }
      }
    });
  
    return EssentialFAQSection;
  })();

  theme.RelatedProductSection = (function() {
    function RelatedProductSection(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
    }
  
    RelatedProductSection.prototype = Object.assign({}, RelatedProductSection.prototype, {
      init: function() {
        var $relatedProducts = $('.related-products .related-product-slider');
        
        $relatedProducts.slick({
          infinite: true,
          speed: 300,
          dots: true,
          autoPlay: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        });
      }
    });
  
    return RelatedProductSection;
  })();

  theme.CustomBlogList = (function() {
    function CustomBlogList(container) {
      this.container = container;
      if (!container) {
        return;
      }

      this.init();
    }
  
    CustomBlogList.prototype = Object.assign({}, CustomBlogList.prototype, {
      init: function() {
        var $loadMoreButton = $('.custom-load-more-btn');
        var toShowNumber = $('.custom-blog-blocks').data('show-blog-number');
        var articles = $('.custom-blog-blocks').data('articles');

        if (articles <= toShowNumber) {
          $loadMoreButton.hide();
        } else {
          $loadMoreButton.show();
        }

        $(".custom-blog-block__wrapper").slice(0, toShowNumber).show();
        if ($(".toShowNumber:hidden").length != 0) {
          $loadMoreButton.show();
        }
        
        $loadMoreButton.on('click', function(e) {
          e.preventDefault();
          $(".custom-blog-block__wrapper:hidden").slice(0, toShowNumber).slideDown();
          if ($(".custom-blog-block__wrapper:hidden").length == 0) {
              $loadMoreButton.fadeOut("slow");
          }
        })
      }
    });
  
    return CustomBlogList;
  })();
  
  /**
   * Theme Registration
   */

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();

    theme.sections.register('custom-content', theme.CustomContent);
    theme.sections.register('reviews', theme.Testimonials);
    theme.sections.register('blog', theme.BlogSection);
    theme.sections.register('aqi-section', theme.AQISection);
    theme.sections.register('filter-tab-section', theme.FilterTabSection);
    theme.sections.register('upsell-product-section', theme.UpsellProductSection);
    theme.sections.register('essential-faq-section', theme.EssentialFAQSection);
    theme.sections.register('related-product-section', theme.RelatedProductSection);
    theme.sections.register('custom-blog-list', theme.CustomBlogList);
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

})(themeVendor.themeCurrency);
